import React, { useState } from 'react';
import { TextField, Button, Grid, Typography, Box, Dialog, DialogContent, DialogActions, DialogTitle, Backdrop, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from '../axios/axios';
import dashboard from '../Assets/Dashboard.png';
import './LoginPage.css';

const LoginPage = ({ onLogin }) => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [promptPassword, setPromptPassword] = useState('');
    const [isPromptVerified, setIsPromptVerified] = useState(false);
    const [promptError, setPromptError] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [showPromptPassword, setShowPromptPassword] = useState(false);

    const handlePromptVerify = () => {
        if (promptPassword === 'Admin1@') {
            setIsPromptVerified(true);
            setPromptError(null);
        } else {
            setPromptError('Invalid prompt password. Please try again.');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'username') {
            setUsername(value);
        } else if (name === 'password') {
            setPassword(value);
        } else if (name === 'promptPassword') {
            setPromptPassword(value);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !isPromptVerified) {
            handlePromptVerify();
        }
    };

    const handleToggleShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const handleToggleShowPromptPassword = () => {
        setShowPromptPassword((prev) => !prev);
    };

    const handleLoginClick = async () => {
        try {
            const response = await axios.post('/users/login', {
                UD_userName: username,
                UD_Password: password,
            });

            if (response.data && response.data.token) {
                localStorage.setItem('auth_token', response.data.token);
                localStorage.setItem('isAuthenticated', 'true');
                onLogin();
                localStorage.setItem("Previlege", JSON.stringify(response.data?.userdetl?.privileges));
                localStorage.setItem("User", response.data?.userdetl?.userId);
                localStorage.setItem("User_Details", JSON.stringify(response.data?.userdetl?.userData));
                navigate('/dashboard');
            } else {
                setError(response.data.message);
            }
        } catch (error) {
            console.log(error)
        }
    };

    return (
        <>
            {/* Modal for Password Prompt */}
            <Backdrop open={!isPromptVerified} sx={{ zIndex: 1200 }}>
                <Dialog
                    open={!isPromptVerified}
                    maxWidth="xs"
                    fullWidth
                    sx={{
                        position: 'absolute',
                        top: '10%',
                        '& .MuiDialog-paper': {
                            borderRadius: '20px',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
                            backgroundColor: '#FFFFFF',
                        },
                    }}
                >
                    <DialogTitle
                        sx={{
                            fontFamily: 'Poppins',
                            fontWeight: 700,
                            fontSize: '24px',
                            color: '#4A3685',
                            textAlign: 'center',
                            margin: 3
                        }}
                    >
                        Enter Password
                    </DialogTitle>
                    <DialogContent sx={{ textAlign: 'center', padding: '20px', margin: 3 }}>
                        <TextField
                            type={showPromptPassword ? 'text' : 'password'}
                            name="promptPassword"
                            value={promptPassword}
                            onChange={handleInputChange}
                            onKeyPress={handleKeyPress}
                            variant="outlined"
                            fullWidth
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleToggleShowPromptPassword}>
                                            {showPromptPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                mb: 2,
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '50px',
                                    '& fieldset': {
                                        borderColor: '#4A3685',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#533592',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#533592',
                                    },
                                },
                                '& .MuiInputLabel-root': {
                                    fontFamily: 'Poppins',
                                    color: '#4A3685',
                                    '&.Mui-focused': {
                                        color: '#533592',
                                    },
                                },
                            }}
                        />
                        {promptError && <Typography color="error">{promptError}</Typography>}
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: 'center', paddingBottom: '20px' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handlePromptVerify}
                            sx={{
                                borderRadius: '50px',
                                padding: '10px 20px',
                                fontFamily: 'Poppins',
                                background: 'linear-gradient(rgba(125, 50, 204, 1), rgba(74, 54, 133, 1))',
                                color: 'white',
                                '&:hover': {
                                    background: 'linear-gradient(rgba(125, 50, 204, 1), rgba(74, 54, 133, 1))',
                                },
                            }}
                        >
                            Verify
                        </Button>
                    </DialogActions>
                </Dialog>
            </Backdrop>

            {/* Main Login Page */}
            <Grid container sx={{ height: '100vh', fontFamily: 'Poppins', filter: !isPromptVerified ? 'blur(5px)' : 'none' }}>
                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 4,
                        bgcolor: 'white',
                    }}
                >
                    <TextField
                        label="Username"
                        variant="outlined"
                        fullWidth
                        name="username"
                        value={username}
                        onChange={handleInputChange}
                        sx={{
                            mb: 2,
                            width: { xs: '80%', md: '60%' },
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '50px',
                                '& fieldset': {
                                    borderColor: '#33388A',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#533592',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#533592',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                fontFamily: 'Poppins',
                                color: '#33388A',
                                '&.Mui-focused': {
                                    color: '#533592',
                                },
                            },
                        }}
                    />
                    <TextField
                        label="Password"
                        type={showPassword ? 'text' : 'password'}
                        variant="outlined"
                        fullWidth
                        name="password"
                        value={password}
                        onChange={handleInputChange}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleToggleShowPassword}>
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            mb: 2,
                            width: { xs: '80%', md: '60%' },
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '50px',
                                '& fieldset': {
                                    borderColor: '#33388A',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#533592',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#533592',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                fontFamily: 'Poppins',
                                color: '#33388A',
                                '&.Mui-focused': {
                                    color: '#533592',
                                },
                            },
                        }}
                    />
                    {error && <Typography color="error">{error}</Typography>}
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                            mt: 2,
                            width: { xs: '80%', md: '60%' },
                            borderRadius: '50px',
                            padding: '10px 20px',
                            fontFamily: 'Poppins',
                            background: 'linear-gradient(rgba(125, 50, 204, 1), rgba(74, 54, 133, 1))',
                            color: 'white',
                            '&:hover': {
                                background: 'linear-gradient(rgba(125, 50, 204, 1), rgba(74, 54, 133, 1))',
                            },
                        }}
                        onClick={handleLoginClick}
                    >
                        Login
                    </Button>
                    <Typography
                        variant="body2"
                        sx={{ mt: 2, fontFamily: 'Poppins', cursor: 'pointer', color: '#979797', fontSize: '16.6px' }}
                    >
                        Forgot Password ?
                    </Typography>
                </Grid>
                {/* Right Side */}
                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        padding: 2,
                        bgcolor: '#4A3685',
                        color: 'white',
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: 'Kodchasan',
                            fontWeight: 700,
                            fontSize: '80px',
                            lineHeight: '100px',
                            color: '#FFFFFF',
                        }}
                    >
                        MSquared License Manager
                    </Typography>
                    <Typography
                        sx={{
                            mt: 7,
                            fontFamily: 'Kodchasan',
                            fontWeight: 700,
                            fontSize: '40px',
                            lineHeight: '52px',
                            color: '#FFFFFF',
                        }}
                    >
                        Login into your account
                    </Typography>
                    <Box
                        component="img"
                        src={dashboard}
                        alt="Dashboard"
                        sx={{ width: '80%', maxWidth: 500, mt: 2 }}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default LoginPage;
